"use client";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getSingleOrderRedux } from "../../actions/index";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { ClipLoader } from "react-spinners";
import { SkyArt, ZigEdge, ThanksStrip, CardIcon } from "./invoiceParts";
import logo from "../../assets/images/brand/kido-logo.png";
import { Download } from "react-feather";
const Invoice = ({ orders, getSingleOrderRedux, match }) => {
  const [loader, setLoader] = useState(false);
  const orderId = match.params.orderId;
  useEffect(() => {
    const getOrder = async () => {
      if (orders && orders.length == 0) {
        await getSingleOrderRedux(orderId);
      }
    };
    getOrder();
  }, []);

  const singleProductTotal = (product) => {
    let total = parseInt(getPrice4(product)) * product.quantity;
    return total;
  };
  const singleProductTotal2 = (product) => {
    let total = parseInt(getPrice3(product)) * product.quantity;
    return total;
  };

  const getPrice3 = (product) => {
    if (product.selectedVariation && product.selectedVariation.id) {
      return product.selectedVariation.price;
    } else {
      if (product.product) {
        return product.product.price;
      } else {
        return 0;
      }
    }
  };

  const getPrice4 = (product) => {
    if (product.selectedVariation && product.selectedVariation.id) {
      if (product.selectedVariation.salePrice == 0) {
        return product.selectedVariation.price;
      } else {
        return product.selectedVariation.salePrice;
      }
    } else {
      if (product.product) {
        if (product.product.salePrice == 0) {
          return product.product.price;
        } else {
          return product.product.salePrice;
        }
      } else {
        return 0;
      }
    }
  };
  // download pdf te image ashe na cors policy er karone request http://localhost theke jay ejonno.https:// request hole maybe thik hobe otherwise cors policy change korte hobe in firebase othobar node js server theke image fetch kore oi image use korte hobe in img src
  const downloadPDF = async () => {
    setLoader(true);
    const invoiceElement = document.getElementById("invoice");
    const images = invoiceElement.querySelectorAll("img");
    const promises = Array.from(images).map((img) => {
      return new Promise((resolve) => {
        if (img.complete) {
          resolve(); // Image is already loaded
        } else {
          img.onload = resolve;
        }
      });
    });
    await Promise.all(promises);
    const canvas = await html2canvas(invoiceElement, {
      // desktop width so the phone layout doesn't apply, and no animations
      windowWidth: 1200,
      onclone: (doc) => doc.documentElement.classList.add("kdv-capturing"),
    });
    const imgData = canvas.toDataURL("image/jpg");

    const pdf = new jsPDF("p", "mm", "a4");
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("invoice.pdf");
    setLoader(false);
  };

  //   const downloadPDF = () => {
  //     setLoader(true);

  //     const invoiceElement = document.getElementById("invoice");

  //     // Wait for all images to load
  //     const images = invoiceElement.querySelectorAll("img");
  //     const promises = Array.from(images).map((img) => {
  //       return new Promise((resolve) => {
  //         if (img.complete) {
  //           resolve(); // Image is already loaded
  //         } else {
  //           img.onload = resolve;
  //         }
  //       });
  //     });

  //     // Wait for all images to load
  //     Promise.all(promises).then(() => {
  //       html2pdf()
  //         .from(invoiceElement)
  //         .save("invoice.pdf")
  //         .then(() => {
  //           setLoader(false);
  //         });
  //     });
  //   };

  let order = null;
  if (orders.length > 0) {
    order = orders.find((order) => order.id == orderId);
  }
  // Default shipping address: registered customer or guest checkout.
  const shipping = order
    ? ((order.currentUser || order.guest || {}).address || []).find(
        (address) => address.defaultShipping
      ) || {}
    : {};
  const totalBill = order
    ? order.subTotal +
      order.deliveryCharge -
      order.discountApplied -
      (order.couponApplied ? order.couponApplied.discount : 0)
    : 0;

  // Same KIDO invoice as the storefront (kido-invoice.css).
  // `#invoice` is what html2canvas captures for the PDF download.
  const firstName = (shipping.fullName || "").trim().split(/\s+/)[0];
  const itemCount = order
    ? order.orders.reduce((s, i) => s + (parseInt(i.quantity, 10) || 0), 0)
    : 0;
  return (
    <div className="kdv-page kdv-page--admin">
      <div className="kdv-toolbar">
        <span />
        <div className="kdv-toolbar-actions">
          <button
            type="button"
            className="kdv-btn kdv-btn--fill"
            onClick={downloadPDF}
            disabled={loader || !order}
          >
            {loader ? (
              <ClipLoader loading={loader} size={16} color="white" />
            ) : (
              <Download size={16} aria-hidden="true" />
            )}
            {loader ? "Preparing PDF…" : "Download invoice"}
          </button>
        </div>
      </div>
      {order && (
        <div className="kdv-scroll">
          <div className="kdv-doc" id="invoice">
            <div className="kdv-sky">
              <SkyArt />
              <div className="kdv-head">
                <div className="kdv-plaque">
                  <img src={logo} alt="KIDO" className="kdv-logo" />
                </div>
                <div className="kdv-head-right">
                  <div className="kdv-title">Invoice</div>
                  <div>
                    <span className="kdv-number">#{order.id}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="kdv-body">
              <div className="kdv-hello">
                <div>
                  Hi {firstName || "there"}!
                  <small>Here&apos;s everything in your KIDO order.</small>
                </div>
              </div>

              <div className="kdv-cards">
                <div className="kdv-card">
                  <div className="kdv-card-label">
                    <CardIcon icon="balloon" color="pink" /> Delivery address
                  </div>
                  <div className="kdv-card-name">{shipping.fullName || "-"}</div>
                  <div className="kdv-card-line">{shipping.mobileNo || "-"}</div>
                  <div className="kdv-card-line">{shipping.address || "-"}</div>
                  <div className="kdv-card-line">
                    {shipping.district ? `${shipping.district}, ` : ""}
                    {shipping.division || ""}
                  </div>
                </div>
                <div className="kdv-card kdv-card--butter">
                  <div className="kdv-card-label">
                    <CardIcon icon="star" color="sun" /> Invoice details
                  </div>
                  <div className="kdv-kv">
                    <span>Order date</span>
                    <strong>
                      {new Date(Number(order.date)).toLocaleDateString()}{" "}
                      {new Date(Number(order.date)).toLocaleTimeString()}
                    </strong>
                  </div>
                  <div className="kdv-kv">
                    <span>Order ID</span>
                    <strong>{order.id}</strong>
                  </div>
                  <div className="kdv-kv">
                    <span>Delivery</span>
                    <strong>Regular delivery</strong>
                  </div>
                </div>
              </div>

              <div className="kdv-items-head">
                <h2 className="kdv-items-title">Your goodies</h2>
                <span className="kdv-items-count">{itemCount}</span>
              </div>
              <div className="kdv-cols" aria-hidden="true">
                <span>Product</span>
                <span>Qty</span>
                <span>Unit price</span>
                <span>Total</span>
              </div>
              <div className="kdv-list">
                {order.orders.map((item, index) => {
                  const price = getPrice4(item);
                  const listPrice = getPrice3(item);
                  const onSale = Number(listPrice) !== Number(price);
                  return (
                    <div className="kdv-item" key={index}>
                      <div className="kdv-product">
                        <span className="kdv-thumb">
                          <img
                            alt="product"
                            src={
                              item.selectedVariation &&
                              item.selectedVariation.id &&
                              item.selectedVariation.pictures &&
                              item.selectedVariation.pictures.length > 0
                                ? item.selectedVariation.pictures[0]
                                : item.product.pictures[0]
                            }
                          />
                        </span>
                        <div>
                          <div className="kdv-product-name">
                            {item.product.name.slice(0, 60)}
                          </div>
                          {item.selectedVariation && item.selectedVariation.id && (
                            <div className="kdv-chips">
                              {item.selectedVariation.combination.map((comb, ci) => {
                                const attr = item.product.savedAttributes.find(
                                  (a) => a.id == comb.parentId
                                );
                                return (
                                  <span key={ci} className="kdv-chip">
                                    {attr ? attr.name : ""}: <strong>{comb.name}</strong>
                                  </span>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                      <span className="kdv-qty">×{item.quantity}</span>
                      <div className="kdv-num">
                        ৳{price}
                        {onSale && <span className="kdv-was">৳{listPrice}</span>}
                      </div>
                      <div className="kdv-num kdv-line-total">
                        ৳{singleProductTotal(item)}
                        {onSale && (
                          <span className="kdv-was">৳{singleProductTotal2(item)}</span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="kdv-bottom">
                <div className="kdv-receipt-wrap">
                  <div className="kdv-receipt">
                    <div className="kdv-trow">
                      <span>Subtotal</span>
                      <span>৳ {order.subTotal}</span>
                    </div>
                    <div className="kdv-trow kdv-trow--minus">
                      <span>Discount applied</span>
                      <span>-৳ {order.discountApplied}</span>
                    </div>
                    {order.couponApplied && (
                      <div className="kdv-trow kdv-trow--minus">
                        <span>Coupon ({order.couponApplied.name})</span>
                        <span>-৳ {order.couponApplied.discount}</span>
                      </div>
                    )}
                    <div className="kdv-trow">
                      <span>Delivery charge</span>
                      <span>+৳ {order.deliveryCharge}</span>
                    </div>
                    <div className="kdv-trow kdv-trow--total">
                      <span>Total bill</span>
                      <span>৳ {totalBill}</span>
                    </div>
                  </div>
                  <ZigEdge />
                </div>
              </div>

              <ThanksStrip />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    orders: state.orders.orders,
  };
};
export default connect(mapStateToProps, {
  getSingleOrderRedux,
})(Invoice);
